import React, { useEffect, useState } from 'react';
import { GroupBase, OptionsOrGroups } from 'react-select';
import { Form as FormBootstrap } from 'react-bootstrap';
import Form from '../../../../components/molecules/forms';
import { successUpdateMsg } from '../../../../components/atoms/const';
import { PlanogramData } from './hooks';
import Modal from '../../../../components/organisms/modals';
import { Delete, Pencil } from '../../../../components/atoms/icons';
/* eslint-disable */
interface UpdateProps {
  formik: any;
  resultUpdateVmColumn: any;
  afterUpdateVmColumn: () => void;
  loadingUpdateVmColumn: boolean;
  inputValue: string;
  // eslint-disable-next-line no-unused-vars
  handleChangeInput: (text: string) => void;
  item: any;
  // eslint-disable-next-line no-unused-vars
  optionsFetcher: (text: string, callback: (options: OptionsOrGroups<{ value: any, label: string }, GroupBase<{ value: string, label: string }>>) => void) => void
  selectedProduct: { value: number | string, label: string }
  // eslint-disable-next-line no-unused-vars
  handleChangeSelectedProduct: (e: { value: number | string, label: string } | null) => void;
  // eslint-disable-next-line no-unused-vars
  onInitModalEdit: (item: PlanogramData) => void
}

function RenderCopyModal(props: any): React.ReactElement {
  const {
    planogramClientList,
    activeClient,
    activeVM,
    selectedVMID,
    handleSelected,
    handleSelectedVM,
    handleSelectedVMCopy,
    onInitModalCopy,
    resultCopyVmColumn,
    afterCopyVmColumn,
    loadingUpdateCopyPlanogram,
  } = props;

  const renderModalBodyCopy = (): string | React.ReactElement => {
    if (!resultCopyVmColumn) {
      return (
        <div>
          <div className='copy-planogram-container'>
            <div className={`copy-planogram-section`}>
              {planogramClientList?.map((list: any, index: number) => (
                <div onClick={() => handleSelected(index)} className={`copy-planogram-box ${index == activeClient ? 'active-copy-planogram' : ''}`}>
                  <span>{list?.name}</span>
                  <svg style={{
                    marginRight: '10px'
                  }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="15px" height="15px" >
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </div>

              ))}
            </div>
            <div className='copy-planogram-section'>
              {activeClient >= 0 &&
                <>
                  {planogramClientList?.[activeClient]?.vendingMachines?.map((list: any, index: number) => (
                    <div className='copy-planogram-box' onClick={() => {
                      handleSelectedVM(list?.id, index)
                    }}>
                      <span>{list?.deviceId}</span>
                      {activeVM == index &&
                        <svg style={{
                          marginRight: '10px'
                        }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="20px" height="20px">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                        </svg>
                      }
                    </div>
                  ))}
                </>
              }
            </div>
          </div>
        </div>
      );
    }
    return successUpdateMsg.SUCCESS_COPY_VM;
  };

  return (
    <Modal.Default
      cancelLabel="Close"
      submitLabel="Copy"
      title="Copy Planogram"
      body={renderModalBodyCopy()}
      closeButton
      size="lg"
      isLoading={loadingUpdateCopyPlanogram}
      result={resultCopyVmColumn}
      isConfirmDisabled={!selectedVMID}
      onAfterResult={afterCopyVmColumn}
      onSubmit={handleSelectedVMCopy}
      onInit={onInitModalCopy}
    >
      <span className="d-flex mx-2" style={{ color: '#18266D', cursor: 'pointer', fontWeight: 500 }}>Copy Planogram</span>
    </Modal.Default>
  );
}

function RenderUpdateModal(props: UpdateProps): React.ReactElement {
  const {
    afterUpdateVmColumn, formik, loadingUpdateVmColumn, resultUpdateVmColumn,
    inputValue, handleChangeInput, item, optionsFetcher, selectedProduct,
    handleChangeSelectedProduct, onInitModalEdit,
  } = props;

  const renderModalBodyUpdate = (): string | React.ReactElement => {
    if (!resultUpdateVmColumn) {
      return (
        <div>
          <Form.ReactSelect.AsyncMode
            id="productId"
            label="Product Name"
            className="mb-4"
            placeholder="Choose Product"
            optionsFetcher={optionsFetcher}
            inputValue={inputValue}
            onChangeInput={handleChangeInput}
            onChangeSelected={(e) => {
              if (e) handleChangeSelectedProduct(e);
            }}
            selectedValue={selectedProduct}
            errorMsg={formik.errors.productId}
            isInvalid={!!formik.errors.productId && formik.touched.productId}
            onBlur={formik.handleBlur}
          />
          <Form.Default
            id="quantity"
            label="Quantity"
            placeholder="Quantity"
            defaultValue={formik.values.quantity}
            readOnly
            className="mb-4"
            disabled={loadingUpdateVmColumn}
          />
          <Form.Default
            id="price"
            label="Price"
            placeholder="Price"
            value={formik.values.price}
            onChange={formik.handleChange}
            isInvalid={!!formik.errors.price && formik.touched.price}
            errorMsg={formik.errors.price}
            onBlur={formik.handleBlur}
            className="mb-4"
            disabled={loadingUpdateVmColumn}
          />
          <div style={{ paddingLeft: 20 }}>
            <FormBootstrap.Check
              id="applyAll"
              label="Apply All Vending Machines"
              type="checkbox"
              checked={formik?.values?.applyAll ?? false}
              onChange={(e) => {
                if (e) formik?.setFieldValue('applyAll', e.target.checked);
              }}
            />
          </div>
        </div>
      );
    }
    return successUpdateMsg.SUCCESS_UPDATE_VM_COLUMN_MSG;
  };
  return (
    <Modal.Default
      cancelLabel="Close"
      submitLabel="Update"
      title="Edit A Product"
      body={renderModalBodyUpdate()}
      onSubmit={formik.handleSubmit}
      isLoading={loadingUpdateVmColumn}
      result={resultUpdateVmColumn}
      onAfterResult={afterUpdateVmColumn}
      closeButton
      size="lg"
      onInit={() => onInitModalEdit(item)}
    >
      <div><Pencil /></div>
    </Modal.Default>
  );
}

interface DeleteProps {
  // eslint-disable-next-line no-unused-vars
  handleDeleteProduct: (columnId: string) => void;
  resultDeleteProduct: any;
  afterDeleteProduct: () => void;
  loadingDeleteProduct: boolean;
  item: PlanogramData;
}

function RenderDeleteModal(props: DeleteProps): React.ReactElement {
  const {
    handleDeleteProduct, afterDeleteProduct, loadingDeleteProduct, resultDeleteProduct, item,
  } = props;
  const renderModalBodyDelete = () => {
    if (!resultDeleteProduct) return 'Are you sure to remove this Product?';
    return successUpdateMsg.SUCCESS_DELETE_PRODUCT_MSG;
  };
  return (
    <Modal.Default
      cancelLabel="No"
      submitLabel="Yes"
      title="Remove Product"
      body={renderModalBodyDelete()}
      size="sm"
      isLoading={loadingDeleteProduct}
      result={resultDeleteProduct}
      onAfterResult={afterDeleteProduct}
      onSubmit={() => handleDeleteProduct(item.id)}
    >
      <div className="me-2 me-xl-3" style={{ marginBottom: '2px' }}><Delete /></div>
    </Modal.Default>
  );
}

const RenderModal = {
  Delete: React.memo(RenderDeleteModal),
  Update: React.memo(RenderUpdateModal),
  Copy: React.memo(RenderCopyModal),
};

export default RenderModal;
